import { createContext, useContext, useLayoutEffect } from "react";
import { OnboardingStepValueType } from "analytics/events";

export const ExploreOnboardingStepContext = createContext<
  (step?: OnboardingStepValueType) => void
>(() => {});

export const useExploreOnboardingStep = (step?: OnboardingStepValueType) => {
  const setStep = useContext(ExploreOnboardingStepContext);
  useLayoutEffect(() => {
    setStep(step);
    return () => setStep(undefined);
  }, [setStep, step]);
};
